<template>
    <div class="d-flex flex-column">

        <p class="mb-1">{{ $t('adjustTheAppearanceOfTheWidgetsAndItsAction') }}</p>

        <div class="mb-4">
            <ButtonIcon
                icon="file-text"
                :icon-size="24"
                href="https://getbuybox.com/konfiguracje/"
                target="_blank"
                variant="link"
                class="p-0"
            >
                {{ $t('readMoreHowYouCanMatchTheWidget') }}
            </ButtonIcon>
        </div>

        <div class="d-flex gap-4">

            <div class="settings-wrapper flex-grow-1 flex-basis-0">

                <h5 class="mb-1"><span id="WTB-Wyglad-header-1" class="text-link-header">{{ $t('colors') }}</span></h5>
                <p>{{ $t('setColorsThatMatchYourSite') }}</p>
                <FormValidator id="form-group-lead-color" form-group label-id="WTB-Wyglad-label-1">
                    <template #label>
                        <div><span id="WTB-Wyglad-label-1" class="text-link-label-1">{{ $t('mainColor') }}</span></div>
                        <div class="font-weight-normal">{{ $t('colorUsedForButtonBackground') }}</div>
                    </template>
                    <ColorField id="form-lead-color" v-model="options.leadColor" :validation="$v.options.leadColor" class="m-0" />
                </FormValidator>
                <div class="w-100 border-bottom my-4"></div>

                <h5 class="mb-1"><span id="WTB-Wyglad-header-2" class="text-link-header">{{ $t('offerList') }}</span></h5>
                <p>{{ $t('decideHowToDisplayOffers') }}</p>
                <FormValidator id="form-group-shop-style" label-id="WTB-Wyglad-label-2" form-group :label="$t('shopPresentation')">
                    <b-form-select id="form-shop-style" v-model="options.shopStyle" :options="optionsShopStyle" />
                </FormValidator>
                <FormValidator id="form-group-sort-type" label-id="WTB-Wyglad-label-3" form-group :label="$t('offerOrder')">
                    <b-form-select id="form-sort-type" v-model="options.sortType" :options="optionsSortType" text-field="label" :disabled="requestBuyboxSortTypes.loading" />
                </FormValidator>
                <FormValidator id="form-group-show-prices" label-id="WTB-Wyglad-label-4" form-group :label="$t('prices')">
                    <b-form-select id="form-show-prices" v-model="options.showPrices" :options="optionsShowPrices" />
                </FormValidator>
                <FormValidator id="form-group-button-label" label-id="WTB-Wyglad-label-5" form-group :label="`${$t('ownContentOfTheButton')} (${$t('maxCharacters', { count: 15 }).toLowerCase()})`">
                    <b-form-input id="form-button-label" v-model.trim="options.buttonLabel" :maxlength="15" />
                </FormValidator>
                <FormValidator id="form-group-row-count" label-id="WTB-Wyglad-label-6" form-group :label="$t('maxDisplayedOffers')">
                    <b-form-input id="form-row-count" v-model.number="options.rowCount" type="number" />
                </FormValidator>
                <div class="w-100 border-bottom my-4"></div>

                <h5 class="mb-1"><span id="WTB-Wyglad-header-3" class="text-link-header">{{ $t('productDetails') }}</span></h5>
                <p>{{ $t('decideWhetherToShowProductInfo') }}</p>
                <FormValidator id="form-group-show-product" label-id="WTB-Wyglad-label-7" form-group :label="$t('productInfoNamePhoto')">
                    <b-form-select id="form-show-product" v-model="options.showProduct" :options="optionsShowProduct" />
                </FormValidator>
                <div class="w-100 border-bottom my-4"></div>

                <h5 class="mb-1"><span id="WTB-Wyglad-header-4" class="text-link-header">{{ $t('formatsTabs') }}</span></h5>
                <p>{{ $t('groupOffersByFormatInTabs') }}</p>
                <FormValidator id="form-group-is-tab" label-id="WTB-Wyglad-label-8" form-group :label="$t('tabs')">
                    <b-form-select id="form-is-tab" v-model="options.isTab" :options="optionsIsTab" />
                </FormValidator>
                <b-collapse v-model="options.isTab">
                    <strong><span id="WTB-Wyglad-label-9">{{ $t('tabs') }}</span></strong>
                    <p>{{ $t('selectFormatsForEachCategory') }}</p>
                    <b-spinner v-if="requestBuyboxSortTypes.getLoading()" class="m-auto d-block" />
                    <div v-else class="accordion d-flex flex-column gap-3">
                        <div v-for="type in optionsTypesAndFormats" :key="type.value">
                            <template v-if="type.value !== 'product'">
                                <ButtonIcon
                                    v-b-toggle="`accordion-${type.value}`"
                                    block
                                    variant="light"
                                    icon="chevron-down"
                                    flip-icon
                                    label-class="flex-grow-1"
                                    size="sm"
                                >
                                    {{ type.label }}
                                </ButtonIcon>
                                <b-collapse :id="`accordion-${type.value}`">
                                    <b-table :key="type.value" :items="type.formats" :fields="formatFields" borderless class="mb-0 mt-2">
                                        <template v-if="type.formats.length" #top-row>
                                            <td class="text-left p-1">{{ $t('all') }}</td>
                                            <td class="text-center p-1">
                                                <b-form-checkbox
                                                    :id="`form-formats-type-all-${type.value}`"
                                                    :name="`formats-${type.value}`"
                                                    size="sm"
                                                    :checked="isAllFormatsChecked(type)"
                                                    :disabled="isAllFormatsChecked(type)"
                                                    @change="updateFormats($event, type.formats.map(({id}) => id))"
                                                />
                                            </td>
                                            <td class="text-right p-1">
                                                <div class="custom-control custom-radio b-custom-control-sm">
                                                    <input
                                                        :id="`form-default-formats-radio-all-${type.value}`"
                                                        type="radio"
                                                        :checked="isAllDefaultFormatsChecked(type)"
                                                        :name="`default-formats-${type.value}`"
                                                        class="custom-control-input"
                                                        @input="updateDefaultFormats()"
                                                    >
                                                    <label class="custom-control-label" :for="`form-default-formats-radio-all-${type.value}`"></label>
                                                </div>
                                            </td>
                                        </template>
                                        <template #cell(show)="{item}">
                                            <b-form-checkbox
                                                :id="`form-formats-type-${type.value}-${item.id}`"
                                                v-model="options.formats"
                                                :value="item.id"
                                                name="formats"
                                                size="sm"
                                                :disabled="isFormatDisabled(type, item)"
                                                @input="uncheckDefaultFormat(type, item)"
                                            />
                                        </template>
                                        <template #cell(default)="{item}">
                                            <div class="custom-control custom-radio b-custom-control-sm" :class="{'d-none': isDefaultFormatDisabled(item)}">
                                                <input
                                                    :id="`form-default-formats-radio-${type.value}-${item.id}`"
                                                    type="radio"
                                                    :checked="isDefaultFormatChecked(item)"
                                                    :disabled="isDefaultFormatDisabled(item)"
                                                    :name="`default-formats-${type.value}`"
                                                    class="custom-control-input"
                                                    :value="item.id"
                                                    @input="updateDefaultFormats()"
                                                >
                                                <label class="custom-control-label" :for="`form-default-formats-radio-${type.value}-${item.id}`"></label>
                                            </div>
                                        </template>
                                    </b-table>
                                    <div v-if="!type.formats.length" class="text-center font-size-14 p-1">{{ $t('noData') }}</div>
                                    <div v-if="requestTypesAndFormats.loading" class="d-flex justify-content-center my-2">
                                        <b-spinner small />
                                    </div>
                                </b-collapse>
                            </template>
                        </div>
                    </div>
                </b-collapse>

                <div class="w-100 border-bottom my-4"></div>

                <h5 class="mb-4"><span id="WTB-Wyglad-header-5" class="text-link-header">{{ $t('additionalSettings') }}</span></h5>
                <FormValidator id="form-group-language" label-id="WTB-Wyglad-label-10" form-group :label="$t('widgetLanguage')">
                    <b-form-select id="form-language" v-model="options.language" :options="optionsLanguage" />
                </FormValidator>
                <FormValidator id="form-group-version" label-id="WTB-Wyglad-label-11" form-group :label="$t('widgetVersion')">
                    <b-form-select id="form-version" v-model="options.version" :options="optionsVersion" />
                </FormValidator>
                <FormValidator id="form-group-show-availability" label-id="WTB-Wyglad-label-12" form-group :label="$t('showAvailability')">
                    <b-form-select id="form-show-availability" v-model="options.showAvailability" :options="optionsShowAvailability" />
                </FormValidator>

                <ButtonIcon class="wide mt-4" :disabled="loading" @click="save()">{{ $t('saveChanges') }}</ButtonIcon>

            </div>

            <div class="d-none d-md-block preview-wrapper flex-grow-1 flex-basis-0">
                <h5 class="mb-1"><span id="WTB-Wyglad-header-6" class="text-link-header">{{ $t('yourWidgetPreview') }}</span></h5>
                <p>{{ $t('seeHowYourWidgetWillLook') }}</p>
                <div class="d-flex gap-3 flex-column">
                    <div v-if="!isMobile()" class="d-flex gap-2 justify-content-center">
                        <ButtonIcon variant="light" size="lg" class="btn-preview-icon p-2" :pressed="previewMode === 'desktop'" @click="previewMode = 'desktop'">
                            <template #icon>
                                <img src="@/assets/images/computer.png" alt="" width="24px" class="">
                            </template>
                        </ButtonIcon>
                        <ButtonIcon variant="light" size="lg" class="btn-preview-icon p-2" :pressed="previewMode === 'mobile'" @click="previewMode = 'mobile'">
                            <template #icon>
                                <img src="@/assets/images/smartphone.png" alt="" width="24px" class="">
                            </template>
                        </ButtonIcon>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div :class="`widget-preview-mode-${previewMode}`" class="w-100 d-flex flex-column justify-content-center align-items-center flex-grow-1 text-center height-min-100">
                            <IframeWidgetPreview
                                v-bind="widgetPreviewData"
                                :reload-delay="100"
                                @BBLoading="widgetLoading = true"
                                @NoData="widgetLoading = false"
                                @BBLoaded="widgetLoading = false"
                            />
                            <b-spinner v-if="widgetLoading" class="m-auto d-block" />
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>



<script>
    import cloneDeep from 'lodash/cloneDeep';
    import pullAll from 'lodash/pullAll';
    import union from 'lodash/union';
    import pick from 'lodash/pick';
    import intersection from 'lodash/intersection';
    import camelCase from 'lodash/camelCase';
    import { scrollToElement, isMobile } from '@/utils/util';
    import FormValidator from '@/components/common/FormValidator.vue';
    import ColorField from '@/components/common/ColorField.vue';
    import { hexColor } from '@/utils/validators';
    import { getLanguageOptions } from '@/i18n/i18n';
    import { translateWidgetVersion, widgetVersions, SortTypeToWidgetSort } from '@/services/pluginService';
    import IframeWidgetPreview from '@/components/common/IframeWidgetPreview.vue';

    const DEFAULT_OPTIONS = Object.freeze({
        language: null,
        leadColor: null,
        buttonLabel: null,
        shopStyle: null,
        sortType: null,
        rowCount: null,
        showProduct: false,
        showPrices: false,
        formats: [],
        defaultFormats: [],
        isTab: false,
        version: 'latest',
        showAvailability: false,
    });

    export default {
        name: 'Appearance',
        components: {
            FormValidator,
            ColorField,
            IframeWidgetPreview,
        },
        validations: {
            options: {
                leadColor: {
                    hexColor: value => (!value ? true : hexColor(value)),
                },
            },
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {
                options: { ...DEFAULT_OPTIONS },
                requestBuyboxSortTypes: this.$req('buyboxes/BuyboxSortTypes'),
                requestTypesAndFormats: this.$req('offers/TypesAndFormats'),
                previewMode: isMobile() ? 'mobile' : 'desktop',
                isMobile,
                widgetLoading: false,
            };
        },
        computed: {
            id() {
                return this.parentComponent.id;
            },
            buybox() {
                return this.parentComponent.buyboxRequest.data;
            },
            loading() {
                return this.parentComponent.buyboxRequest.loading;
            },
            buyboxFormatsDefaultIds() {
                return this.buybox.formats.filter(item => item.default).map(item => item.format.id);
            },
            optionsLanguage() {
                return getLanguageOptions(true);
            },
            optionsShopStyle() {
                return this.$store.getters['options/shopStyleOptions'];
            },
            optionsSortType() {
                return this.requestBuyboxSortTypes.data;
            },
            optionsShowPrices() {
                return [
                    { text: this.$t('showPrices'), value: true },
                    { text: this.$t('hidePrices'), value: false },
                ];
            },
            optionsIsTab() {
                return [
                    { text: this.$t('groupIntoTabs'), value: true },
                    { text: this.$t('dontGroupIntoTabs'), value: false },
                ];
            },
            optionsShowProduct() {
                return [
                    { text: this.$t('showProductInfo'), value: true },
                    { text: this.$t('dontShowProductInfo'), value: false },
                ];
            },
            optionsShowAvailability() {
                return [
                    { text: this.$t('yes'), value: true },
                    { text: this.$t('no'), value: false },
                ];
            },
            optionsTypesAndFormats() {
                return this.requestTypesAndFormats.data;
            },
            optionsVersion() {
                return widgetVersions.map(version => ({
                    value: version,
                    text: translateWidgetVersion(version),
                }));
            },
            formatFields() {
                return [
                    { key: 'categoryName', label: this.$t('format'), tdClass: 'text-left p-1', thClass: 'text-left p-1 border-bottom' },
                    { key: 'show', label: this.$t('display'), tdClass: 'text-center p-1', thClass: 'text-center p-1 border-bottom' },
                    { key: 'default', label: this.$t('defaultTab'), tdClass: 'text-right p-1', thClass: 'text-right p-1 border-bottom' },
                ];
            },
            widgetData() {
                const attrs = {};

                attrs['data-bb-id'] = this.id;
                attrs['data-bb-oid'] = 0;
                if (this.options.language) attrs['data-bb-language'] = this.options.language;
                if (this.options.shopStyle) attrs['data-bb-shop-style'] = this.options.shopStyle;
                if (this.options.sortType) attrs['data-bb-sort'] = SortTypeToWidgetSort[this.options.sortType];
                if (hexColor(this.options.leadColor)) attrs['data-bb-lead-color'] = this.options.leadColor;
                if (this.options.buttonLabel) attrs['data-bb-button-label'] = this.options.buttonLabel;
                if (this.options.rowCount) attrs['data-bb-row-count'] = this.options.rowCount;
                if ([true, false].includes(this.options.showProduct)) attrs['data-bb-show-extra'] = this.options.showProduct;
                if ([true, false].includes(this.options.showPrices)) attrs['data-bb-show-prices'] = this.options.showPrices;
                if (this.options.formats?.length && this.optionsTypesAndFormats?.length)
                    attrs['data-bb-formats'] = this.optionsTypesAndFormats
                        .flatMap(item => item.formats)
                        .filter(format => new Set(this.options.formats).has(format.id))
                        .map(format => format.categoryName)
                        .join(',');
                if (this.options.defaultFormats?.length && this.optionsTypesAndFormats?.length)
                    attrs['data-bb-default-formats'] = this.optionsTypesAndFormats
                        .flatMap(item => item.formats)
                        .filter(format => new Set(this.options.defaultFormats).has(format.id))
                        .map(format => format.categoryName)
                        .join(',');

                return attrs;
            },
            widgetPreviewData() {
                return Object.keys(this.widgetData).reduce((attrs, attrString) => {
                    const attrName = camelCase(attrString.replace('data-', ''));
                    return { ...attrs, [attrName]: this.widgetData[attrString] };
                }, {});
            },
            optionsInitialFormatIds() {
                const availableFormatIds = (this.requestTypesAndFormats.data || []).reduce((acc, item) => {
                    acc[item.value] = item.formats.map(format => format.id); // eslint-disable-line no-param-reassign
                    return acc;
                }, {});
                const buyboxFormatIds = (this.buybox.formats || []).reduce((acc, item) => {
                    const curr = acc[item.format.category.type] || [];
                    acc[item.format.category.type] = [...curr, item.format.id]; // eslint-disable-line no-param-reassign
                    return acc;
                }, {});
                const initialIds = Object.keys(availableFormatIds).reduce((acc, key) => {
                    const formatCommonIds = intersection(availableFormatIds[key], buyboxFormatIds[key]);
                    const currentIds = formatCommonIds.length ? [...formatCommonIds] : [...availableFormatIds[key]];
                    return [...acc, ...currentIds];
                }, []);
                return initialIds;
            },
        },
        watch: {
            buybox: {
                immediate: true,
                handler() {
                    this.resetOptions();
                    if (this.buybox) this.initOptions();
                },
            },
            'requestTypesAndFormats.data': {
                handler() {
                    this.options.formats = this.optionsInitialFormatIds;
                },
            },
        },
        methods: {
            intersection,
            fetchBuyboxSortTypes() {
                this.requestBuyboxSortTypes.get();
            },
            fetchTypesAndFormats() {
                this.requestTypesAndFormats.get();
            },
            updateDefaultFormats() {
                this.options.defaultFormats = Array.from(document.querySelectorAll('input[name^="default-formats"]:checked'))
                    .filter(item => Number.parseInt(item.value))
                    .map(item => Number.parseInt(item.value));
            },
            updateFormats(checked, ids) {
                if (checked) {
                    this.options.formats = union(ids, this.options.formats);
                } else {
                    this.options.formats = pullAll([...this.options.formats], ids);
                }
            },
            resetOptions() {
                this.options = { ...DEFAULT_OPTIONS };
            },
            initOptions() {
                if (!this.buybox) return;
                const buyboxClone = cloneDeep(this.buybox);
                const buyboxPick = pick(buyboxClone, Object.keys(this.options));
                this.options = {
                    ...this.options,
                    ...buyboxPick,
                    formats: this.optionsInitialFormatIds,
                    defaultFormats: (buyboxClone.formats || []).reduce((acc, item) => (item.default ? [...acc, item.format.id] : acc), []),
                };
            },
            async save() {
                this.$v.options.$touch();
                if (this.$v.options.$invalid) {
                    await this.$nextTick();
                    scrollToElement('.is-invalid', { offset: -80 });
                    return;
                }
                this.parentComponent.buyboxRequest.patch({ urlParams: { id: this.id }, requestParams: this.options });
            },
            isAllFormatsChecked(type) {
                return type.formats.every(item => this.options.formats.includes(item.id));
            },
            isAllDefaultFormatsChecked(type) {
                return !intersection(
                    this.buyboxFormatsDefaultIds,
                    type.formats.map(({ id }) => id)
                ).length;
            },
            isFormatDisabled(type, item) {
                const idsSelected = intersection(
                    type.formats.map(({ id }) => id),
                    this.options.formats
                );
                return idsSelected.length === 1 && idsSelected[0] === item.id;
            },
            isDefaultFormatChecked(item) {
                return this.options.defaultFormats.includes(item.id);
            },
            isDefaultFormatDisabled(item) {
                return !this.options.formats.includes(item.id);
            },
            uncheckDefaultFormat(type, item) {
                if (this.isDefaultFormatChecked(item) && !this.options.formats.find(id => id === item.id)) {
                    this.options.defaultFormats = this.options.defaultFormats.filter(id => id !== item.id);
                    document.querySelector(`#form-default-formats-radio-all-${type.value}`).checked = true;
                }
            },
        },
        created() {
            this.fetchBuyboxSortTypes();
            this.fetchTypesAndFormats();
        },
    };
</script>



<style lang="scss" scoped>
    .btn-preview-icon {
        &:active,
        &:focus {
            box-shadow: none !important;
        }
    }

    .widget-preview-mode-desktop {
        width: 760px;
        min-width: 760px;
    }

    .widget-preview-mode-mobile {
        width: 400px;
        min-width: 400px;
        max-width: 400px;
    }
</style>

